import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { SeasonData } from '@pool-league/shared-data-api';
import { CompetitionLinkComponent } from '@pool-league/frontend-web-ui-common';
import { getAttributes } from '../util/competition';

@Component({
  selector: 'lib-web-competition-links',
  imports: [CompetitionLinkComponent],
  templateUrl: './competition-links.component.html',
  styleUrl: './competition-links.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompetitionLinksComponent {
  readonly seasonBaseUrl = input<string | unknown[]>([]);
  readonly competitions = input<SeasonData['competitions'] | undefined>(
    undefined,
  );

  readonly competitionLinks = computed(() => [
    {
      ...this.competitions()?.eightBallRoundRobin,
      link: buildLink(this.seasonBaseUrl(), '8-league'),
      icon: 'img/table/table.png',
      name: 'League',
      attributes: getAttributes(this.competitions()?.eightBallRoundRobin),
    },
    {
      ...this.competitions()?.eightBallKnockout,
      link: buildLink(this.seasonBaseUrl(), '8-cup'),
      icon: 'img/tree/tree.png',
      name: 'Cup',
      attributes: getAttributes(this.competitions()?.eightBallKnockout),
    },
  ]);
}

function buildLink(base: string | unknown[], target: string) {
  if (!base.length) {
    return target;
  }
  if (typeof base === 'string') {
    return [base, target];
  }
  return [...base, target];
}
